onComplete(function () {

	/* Nav items animation variable */
	const navItems = document.querySelectorAll('.navbar-overlay-content .navbar-nav > .nav-item');

	navItems.forEach((link, index) => {
		link.style.setProperty('--i', index + 1);
	});

	/* Quick menu */

	const contentSection = document.querySelector('.content-subtemplate-content');
	const quickMenu = document.querySelector('.quick-menu');

	if (!contentSection || !quickMenu) return;

	const headings = contentSection.querySelectorAll('h2');

	headings.forEach(function (h2) {

		const slug = 'content-' + h2.textContent
			.trim()
			.toLowerCase()
			.normalize('NFD') // accenten opsplitsen
			.replace(/[\u0300-\u036f]/g, '') // accenten verwijderen
			.replace(/[^a-z0-9\s-]/g, '') // speciale tekens weggooien
			.replace(/\s+/g, '-') // spaties → koppeltekens
			.replace(/-+/g, '-') // dubbele koppeltekens opschonen
			.replace(/^-|-$/g, ''); // voorloop/naloop koppeltekens

		h2.id = slug;

		const quickLink = document.createElement('a');
		quickLink.href = '#' + slug;
		quickLink.classList.add('btn');
		quickLink.textContent = h2.textContent.trim();

		quickMenu.appendChild(quickLink);
	});
});